import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  globalSearchFilterOptions: [],
  outreachSimulationUpdatedFilterData: []
}

const globalSearchSlice = createSlice({
  name: 'globalSearch',
  initialState,
  reducers: {
    setGlobalSearchFilterOptions: (state, action) => {
      state.globalSearchFilterOptions = action.payload
    },
    setOutreachSimulationUpdatedFilterData: (state, action) => {
      state.outreachSimulationUpdatedFilterData = action.payload
    }
  }
})

export const {setGlobalSearchFilterOptions, setOutreachSimulationUpdatedFilterData} = globalSearchSlice.actions

// Selectors with null-safe defaults
export const selectGlobalSearchFilterOptions = (state) => state.globalSearch?.globalSearchFilterOptions ?? []
export const selectOutreachSimulationUpdatedFilterData = (state) =>
  state.globalSearch?.outreachSimulationUpdatedFilterData ?? []

export default globalSearchSlice.reducer
